const LOG_ENDPOINT = "/api/client-logs";
const BATCH_INTERVAL = 2000;
const MAX_BATCH_SIZE = 20;

const buffer = [];
let timer = null;

function flush() {
	if (buffer.length === 0) return;

	const entries = buffer.splice(0, MAX_BATCH_SIZE);
	timer = null;

	if (typeof navigator !== "undefined" && navigator.sendBeacon) {
		const blob = new Blob([JSON.stringify(entries)], {
			type: "application/json"
		});
		navigator.sendBeacon(LOG_ENDPOINT, blob);
	} else if (typeof fetch !== "undefined") {
		fetch(LOG_ENDPOINT, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(entries),
			keepalive: true
		}).catch(() => {});
	}

	if (buffer.length > 0) {
		timer = setTimeout(flush, BATCH_INTERVAL);
	}
}

function scheduleFlush() {
	if (!timer) {
		timer = setTimeout(flush, BATCH_INTERVAL);
	}
}

export function forwardLog({ level, message, "x-trace-id": xTraceId }) {
	if (typeof window === "undefined") return;

	buffer.push({
		level,
		message,
		"x-trace-id": xTraceId || "N/A",
		url: window.location.href,
		userAgent: navigator.userAgent,
		timestamp: new Date().toISOString()
	});

	if (buffer.length >= MAX_BATCH_SIZE) {
		flush();
	} else {
		scheduleFlush();
	}
}

if (typeof window !== "undefined") {
	window.addEventListener("beforeunload", flush);
}
